import { render, staticRenderFns } from "./ResultDetailCard.vue?vue&type=template&id=ab52f426"
import script from "./ResultDetailCard.vue?vue&type=script&lang=js"
export * from "./ResultDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ResultDetailCard.vue?vue&type=style&index=0&id=ab52f426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports